// extracted by mini-css-extract-plugin
export var aircallIframe = "_ez-3";
export var fabContainer = "_ez-5";
export var fabRinging = "_ez-6";
export var loadingOverlay = "_ez-4";
export var pulse = "_ez-7";
export var widgetContent = "_ez-2";
export var widgetPanel = "_ez-0";
export var widgetPanelExpanded = "_ez-1";